class LocalizationForm extends HTMLElement {
	constructor() {
		super();
		this.elements = {
			input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
			button: this.querySelector("button"),
			panel: this.querySelector("ul"),
		};
		// this.elements.button.addEventListener('click', this.openSelector.bind(this));
		// this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
		this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

		this.querySelectorAll("a").forEach((item) => item.addEventListener("click", this.onItemClick.bind(this)));
	}

	hidePanel() {
		this.elements.button.setAttribute("aria-expanded", "false");
		this.elements.panel.setAttribute("hidden", true);
	}

	onContainerKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		this.hidePanel();
		this.elements.button.focus();
	}

	onItemClick(event) {
		event.preventDefault();
		const form = this.querySelector("form");
		this.elements.input.value = event.currentTarget.dataset.value;
		if (form) form.submit();
	}

	openSelector() {
		this.elements.button.focus();
		this.elements.panel.toggleAttribute("hidden");
		this.elements.button.setAttribute("aria-expanded", (this.elements.button.getAttribute("aria-expanded") === "false").toString());
	}

	closeSelector(event) {
		const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
		if (event.relatedTarget === null || shouldClose) {
			this.hidePanel();
		}
	}
}

customElements.define("localization-form", LocalizationForm);
class CollapsibleContent extends HTMLElement {
	constructor() {
		super();
		this.attachShadow({ mode: "open" });
		this.shadowRoot.innerHTML = `
        <slot></slot>
      `;
	}
}

class CollapsibleButton extends HTMLElement {
	constructor() {
		super();
		this.attachShadow({ mode: "open" });
		this.shadowRoot.innerHTML = `
        <slot></slot>
      `;
	}

	connectedCallback() {
		this.addEventListener("click", () => this.handleClick());
		if (this.getAttribute("close-on-click")) document.addEventListener("click", (event) => this.handleDocumentClick(event));
	}

	disconnectedCallback() {
		this.removeEventListener("click", () => this.handleClick());
		if (this.getAttribute("close-on-click")) document.removeEventListener("click", (event) => this.handleDocumentClick(event));
	}

	handleClick() {
		const targetId = this.getAttribute("target-id");
		const content = document.querySelector(`[data-id="${targetId}"]`);
		if (content) {
			content.classList.toggle("en-active");
			this.classList.toggle("en-opened");
		}
	}

	handleDocumentClick(event) {
		const isInsideButton = this.contains(event.target);
		if (!isInsideButton) {
			const targetId = this.getAttribute("target-id");
			const content = document.querySelector(`[data-id="${targetId}"]`);
			if (content && content.classList.contains("en-active")) {
				content.classList.remove("en-active");
				this.classList.remove("en-opened");
			}
		}
	}
}

customElements.define("collapsible-content", CollapsibleContent);
customElements.define("collapsible-button", CollapsibleButton);

class RemoveFilter extends HTMLElement {
	constructor() {
		super();
		this.url = this.getAttribute("data-url");
	}

	connectedCallback() {
		this.addEventListener("click", () => this.handleClick());
	}
	disconnectedCallback() {
		this.addEventListener("click", () => this.handleClick());
	}

	handleClick() {
		this.productsOverlayGrid = document.querySelector("#products-grid-overlay");
		this.productsGrid = document.querySelector("#products-grid");
		this.productsOverlayGrid.classList.add("bg-[rgba(var(--primary-background))]", "z-[101]");
		this.filterComponent = document.querySelector("#en-filters");
		fetch(this.url)
			.then((response) => response.text())
			.then((data) => {
				const html = new DOMParser().parseFromString(data, "text/html");
				this.productsGrid.innerHTML = html.getElementById("products-grid").innerHTML;
				this.filterComponent.innerHTML = html.getElementById("en-filters").innerHTML;
				window.history.replaceState({}, "", this.url);
			})
			.catch((error) => {
				console.error("Error fetching data:", error);
			})
			.finally(() => {
				document.querySelector("#products-grid-overlay").classList.remove("bg-[rgba(var(--primary-background))]", "z-[101]");
			});
	}
}

customElements.define("remove-filter", RemoveFilter);

class FilterForm extends HTMLElement {
	constructor() {
		super();
		this.attachShadow({ mode: "open" });
		this.shadowRoot.innerHTML = `
          <slot></slot>
        `;
		this.inputs = this.querySelectorAll("input, select");

		this.handleFormChange = this.handleFormChange.bind(this);
		this.setupEventListeners();
	}

	connectedCallback() {
		this.querySelector("form").addEventListener("submit", (event) => {
			event.preventDefault();
			this.handleFormChange();
		});
	}

	setupEventListeners() {
		this.inputs.forEach((input) => {
			input.addEventListener("change", this.handleFormChange);
		});
	}

	handleFormChange() {
		this.productsGrid = document.querySelector("#products-grid");
		this.filterComponent = document.querySelector("#active-filters");
		const formData = new FormData(this.querySelector("form"));
		const formString = new URLSearchParams(formData).toString();
		const url = `${window.location.pathname}?${formString}`;
		document.querySelector("#products-grid-overlay").classList.add("bg-[rgba(var(--primary-background))]", "z-[101]");
		fetch(url)
			.then((response) => response.text())
			.then((data) => {
				const html = new DOMParser().parseFromString(data, "text/html");
				this.productsGrid.innerHTML = html.getElementById("products-grid").innerHTML;
				this.filterComponent.innerHTML = html.getElementById("active-filters").innerHTML;
				this.updateURL(`${window.location.pathname}?${formString}`);
			})
			.catch((error) => {
				console.error("Error fetching data:", error);
			})
			.finally(() => {
				document.querySelector("#products-grid-overlay").classList.remove("bg-[rgba(var(--primary-background))]", "z-[101]");
			});
	}

	updateURL(url) {
		window.history.replaceState({}, "", url);
	}
}

customElements.define("filter-form", FilterForm);

class PriceRange extends HTMLElement {
	constructor() {
		super();
		this.range1 = this.querySelector("#range1");
		this.range2 = this.querySelector("#range2");
		this.slider1 = this.querySelector("#slider-1");
		this.slider2 = this.querySelector("#slider-2");
	}

	connectedCallback() {
		this.slider1.addEventListener("input", () => this.changeRange1());
		this.slider2.addEventListener("input", () => this.changeRange2());
		this.range1.addEventListener("input", () => this.changeSlide1());
		this.range2.addEventListener("input", () => this.changeSlide2());
	}
	disconnectedCallback() {
		this.slider1.removeEventListener("input", () => this.changeRange1());
		this.slider2.removeEventListener("input", () => this.changeRange2());
		this.range1.removeEventListener("input", () => this.changeSlide1());
		this.range2.removeEventListener("input", () => this.changeSlide2());
	}

	changeSlide1() {
		if (this.range1.value <= parseInt(this.range2.value)) {
			this.slider1.value = parseInt(this.range1.value);
		} else {
			this.range1.value = parseInt(this.range2.value) - 1;
		}
	}

	changeSlide2() {
		if (parseInt(this.range2.value) > this.range1.value) {
			this.slider2.value = parseInt(this.range2.value);
		} else {
			this.range2.value = parseInt(this.range1.value) + 1;
		}
	}

	changeRange1() {
		if (parseInt(this.slider1.value) <= parseInt(this.slider2.value)) {
			this.range1.value = parseInt(this.slider1.value);
		} else {
			this.slider1.value = parseInt(this.slider2.value) - 1;
		}
	}

	changeRange2() {
		if (parseInt(this.slider2.value) > parseInt(this.slider1.value)) {
			this.range2.value = parseInt(this.slider2.value);
		} else {
			this.slider2.value = parseInt(this.slider1.value) + 1;
		}
	}
}

customElements.define("price-range", PriceRange);

class ModelViewer extends HTMLElement {
	constructor() {
		super();
		this.attachShadow({ mode: "open" });
		this.shadowRoot.innerHTML = `
          <slot></slot>
        `;

		this.closeButton = this.querySelector("#model-close");
		this.openButton = this.querySelector("#model-open");
		this.model = this.querySelector("model-viewer");
		this.modelOverlay = this.querySelector("#model-overlay");
	}

	connectedCallback() {
		this.closeButton.addEventListener("click", () => this.closeModel());
		this.openButton.addEventListener("click", () => this.openModel());
	}

	disconnectedCallback() {
		this.closeButton.removeEventListener("click", () => this.closeModel());
		this.openButton.removeEventListener("click", () => this.openModel());
	}

	openModel() {
		this.model.style.pointerEvents = "all";
		this.openButton.classList.add("hidden");
		this.closeButton.classList.remove("hidden");
		this.modelOverlay.classList.add("hidden");
	}

	closeModel() {
		this.model.style.pointerEvents = "none";
		this.closeButton.classList.add("hidden");
		this.openButton.classList.remove("hidden");
		this.modelOverlay.classList.remove("hidden");
	}
}

customElements.define("en-model-viewer", ModelViewer);

class VariantSelector extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.addEventListener("change", this.onVariantChange);
	}

	disconnectedCallback() {
		this.removeEventListener("change", this.onVariantChange);
	}

	onVariantChange() {
		const currentForm = this.closest("ajax-cart-product-form");
		this.disableButtons(currentForm);
		if (currentForm.querySelector("#setSwatches")) {
			this.selectSame();
		}
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.plans) {
			this.getSellingPlans();
		}

		if (this.currentVariant) {
			const productpageForm = this.closest("#details[product-main-form]");
			if (productpageForm) {
				this.updateURL();
				this.updateVar(productpageForm);
			}
			this.updateFormID(currentForm);
			this.updatePrice(currentForm);
			this.updateOthers();
			this.updateButtons(currentForm);
			this.autoSubmit(currentForm);
		}
		if (this.sellingPlan) {
			this.updateSellingPlan(currentForm);
		}
	}
	selectSame() {
		// Select all checked radio buttons and extract their values into an array
		let getValues = Array.from(this.querySelectorAll('input[type="radio"]:checked'), (input) => input.value);

		// Check the first unchecked radio with the same value
		const sameVar = Array.from(this.querySelectorAll('input[type="radio"]:not(:checked)'), (input) => input).filter((input) => input.value === getValues[0]);

		if (sameVar.length > 0) {
			sameVar.forEach((radio) => {
				radio.checked = true;
			});
		}

		let options = [];
		sameVar.forEach((radio) => {
			options.push(radio.value);
		});

		this.options = options;
	}

	disableButtons(currentForm) {
		let buttons = currentForm.querySelectorAll('[name="add"]');
		if (!buttons) return;
		buttons.forEach((button) => {
			button.setAttribute("disabled", "disabled");
		});
	}

	autoSubmit(currentForm) {
		if (currentForm.hasAttribute('autosubmit')) {
			let submitBtn = currentForm.querySelector('[name="add"]');
			let refreshPopup = document.getElementById('refreshPopup');
			currentForm.closest('.product-popup')?.classList.add("opacity-50");
			submitBtn.click();
	
			document.addEventListener("liquid-ajax-cart:request-end", function(event) {
				refreshPopup.click();
			}, { once: true }); 
		}
	}
	

	updateButtons(currentForm) {
		let buttons = currentForm.querySelectorAll('[name="add"]');
		if (!buttons) return;
		let sellingPlanInput = currentForm.querySelector('input[name="selling_plan"]');
		if (!sellingPlanInput || !sellingPlanInput.value.trim()) {
			
			if (this.currentVariant.available == true || this.currentVariant.available == 'only-few-left') {
				buttons.forEach((button) => {
					button.removeAttribute("disabled");
					button.removeAttribute("sold");
					let btnText = button.querySelector(".btn-text");
					if (btnText) if (btnText.getAttribute("text-atc")) btnText.textContent = btnText.getAttribute("text-atc");
					if (this.currentVariant.available === 'only-few-left') {
						var element = document.querySelector('div[type="'+this.currentVariant.available+'"]');
						if (element) {
							element.style.display = 'block'; 
						}
					}
					
				});
			} else {
				buttons.forEach((button) => {
					
					button.setAttribute("sold", "");
					button.setAttribute("disabled", "disabled");
					let btnText = button.querySelector(".btn-text");
					if (btnText) if (btnText.getAttribute("text-sold")) btnText.textContent = btnText.getAttribute("text-sold");
					if (this.currentVariant.available === 'coming-soon') {
						var element = document.querySelector('div[type="'+this.currentVariant.available+'"]');
						if (element) {
							element.style.display = 'block'; 
						}
					}
 
				});
			}
		}
		var otherElements = document.querySelectorAll('div[type]:not([type="'+this.currentVariant.available+'"])');
		otherElements.forEach(function(element) {
			element.style.display = 'none';
		});
	}
	updateSellingPlan(currentForm) {
		const form_input = currentForm.querySelector('input[name="selling_plan"]');
		form_input.value = this.sellingPlan.id;

		const selling_plan_name = currentForm.querySelector('input[name="selling_plan_name"]');
		selling_plan_name.value = this.sellingPlan.name.replace(this.currentVariant.title, "").trim().toLowerCase();
		selling_plan_name.dispatchEvent(new Event("newplan"));
	}

	getSelectedOptions() {
		let selectedInputs = Array.from(this.querySelectorAll('input[type="radio"]:checked'));
		let selectedValues = [];
		let selectedPlans = [];

		selectedInputs.forEach((input) => {
			selectedValues.push(input.value);
			selectedPlans.push(input.getAttribute("data-plan"));
		});
		this.options = selectedValues;
		if (selectedPlans.length > 0 && selectedPlans.some((plan) => plan !== null)) {
			this.plans = selectedPlans;
		}
	}

	getDataJSON() {
		this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	getSelectedVariant() {
		this.currentVariant = this.getDataJSON().variants.find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);

			if (findings) return variant;
		});
	}

	getSellingPlans() {
		this.getDataJSON().selling_plan_groups.forEach((selling_plan_group) => {
			const matchingPlan = selling_plan_group.selling_plans.find((plan) => {
				return this.plans.map((plan) => plan.toLowerCase()).includes(plan.name.toLowerCase());
			});
			if (matchingPlan) {
				this.sellingPlan = matchingPlan;
				return;
			}
		});
	}

	updateURL() {
		if (!this.currentVariant) return;
		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	updateFormID(currentForm) {
		const form_input = currentForm.querySelector('input[name="id"]');
		const all_forms = document.querySelectorAll("ajax-cart-product-form");

		let selectedInputs = Array.from(currentForm.querySelectorAll("input[global-var]:checked"));
		if (selectedInputs.length > 0) {
			all_forms.forEach((form) => {
				if (form.hasAttribute("override-variant")) {
					form.setAttribute("override-variant", this.currentVariant.id);
				}
			});
		}

		let selectedVar = currentForm.getAttribute("override-variant");
		form_input.value = selectedVar ? selectedVar : this.currentVariant.id;
	}

	updateVar(productpageForm) {
		const varTextElement = productpageForm.querySelector("#varName");

		if (varTextElement) {
			const setSwatchesElement = productpageForm.querySelector("#setSwatches");
			if (setSwatchesElement) {
				varTextElement.textContent = this.currentVariant.title.split("/")[0].trim();
			} else {
				varTextElement.textContent = this.currentVariant.title;
			}
		}

		const varNameTextElement = productpageForm.querySelector("#varNameText");
		if (varNameTextElement) {
			varNameTextElement.textContent = this.currentVariant.additional_text || "";
		}
	}

	updatePrice(currentForm) {
		const oldPrices = currentForm.querySelectorAll(`span[data-oldprice]`);
		const newPrices = currentForm.querySelectorAll(`span[data-newprice]`);
		const formatter = new Intl.NumberFormat(document.documentElement.lang, {
			style: "currency",
			currency: window.Shopify.currency.active,
		});

		if (oldPrices.length > 0 && this.currentVariant.compare_at_price) {
			oldPrices.forEach((oldPrice) => {
				oldPrice.innerHTML = formatter.format(this.currentVariant.compare_at_price / 100).replace(/\./, ",");
			});
		}

		if (newPrices.length > 0) {
			newPrices.forEach((newPrice) => {
				if (newPrice.hasAttribute("save-price")) {
					var savePrice = newPrice.getAttribute("save-price");
					var price = this.currentVariant.price;
					var updatedPrice = price - savePrice;
					newPrice.innerHTML = formatter.format(updatedPrice / 100).replace(/\./, ",");
				} else {
					newPrice.innerHTML = formatter.format(this.currentVariant.price / 100).replace(/\./, ",");
				}
			});
		}
	}

	updateOthers() {
		fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");

				const oldMedia = document.querySelector("#product-media");
				const newMedia = html.querySelector("#product-media");

				if (oldMedia && newMedia) oldMedia.innerHTML = newMedia.innerHTML;

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}
			});
	}
}


customElements.define("variant-selector", VariantSelector);

// Quantity Button Custom Element
class QuantityButton extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("click", this.onClick.bind(this));
		this.input = this.parentElement.querySelector("input");
		this.input.addEventListener("change", this.onClick.bind(this), this.getAttribute("data-section"));
	}

	onClick() {
		const input = this.parentElement.querySelector("input");
		let value = Number(input.value);
		const isPlus = this.classList.contains("plus");

		if (isPlus) {
			input.value = value + 1;
		} else if (value > 1) {
			input.value = value - 1;
		}
	}
}

// Define the custom elements
customElements.define("quantity-button", QuantityButton);

class QuickAdd extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.addEventListener("click", (event) => this.handleClick(event));
	}

	disconnectedCallback() {
		this.removeEventListener("click", (event) => this.handleClick(event));
	}

	handleClick(event) {
		if (event.target.classList.contains("fixed") || event.target.classList.contains("close-modal")) {
			this.classList.toggle("hidden");
			document.body.classList.remove("overflow-hidden");
			
			const popup = document.querySelectorAll("[id^='QuickAddInfo-']");
			if (popup.length > 0) {
				popup.forEach(element => {
					element.innerHTML = "";
				});
			}
		}
	}
}
customElements.define("quick-add-modal", QuickAdd);

class QuickAddOpener extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.addEventListener("click", () => this.openQuickAdd(this));
	}

	disconnectedCallback() {
		this.removeEventListener("click", () => this.openQuickAdd(this));
	}

	openQuickAdd = (opener) => {
		this.querySelector(".spinner--overlay")?.classList.remove("hidden");
		this.querySelector(".btn-text")?.classList.add("hidden");
	 	this.closest(".product-card")?.setAttribute("modal-open", this.getAttribute("data-id")); 

		this.targetId = this.getAttribute("target-quickadd-id");
		this.drawer = document.querySelector(`[quickadd-id="${this.targetId}"]`);
		if (this.drawer) {
			fetch(opener.getAttribute("data-product-url"))
				.then((response) => response.text())
				.then((responseText) => {
					const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
					const productElement = responseHTML.querySelector('[id^="ProductPopup-"]');
					let id = "QuickAddInfo-" + opener.getAttribute("data-id").replace(" ", "");
					const targetElement = document.getElementById(id);
					targetElement.innerHTML = productElement.innerHTML;
					//console.log(responseHTML);
					// Reinjects the script tags to allow execution.
					targetElement.querySelectorAll("script").forEach((oldScriptTag) => {
						const newScriptTag = document.createElement("script");
						Array.from(oldScriptTag.attributes).forEach((attribute) => {
							newScriptTag.setAttribute(attribute.name, attribute.value);
						});
						newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
						oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
					});

					const planInput = targetElement.querySelector('button[data-plan-name=""][plan]');
					if (planInput) {
						planInput.setAttribute("data-plan-name", document.getElementById(id).getAttribute("data-plan-name"));
					}

					if (window.Shopify && Shopify.PaymentButton) {
						Shopify.PaymentButton.init();
					}
				})
				.finally(() => {
					this.drawer.classList.remove("hidden");
					document.body.classList.add("overflow-hidden");
					const checkpopup =  this.drawer.querySelector('.product-popup');
					if(!checkpopup){
					this.drawer.classList.add("hidden");
					document.body.classList.remove("overflow-hidden");
			}
					this.querySelector(".spinner--overlay")?.classList.add("hidden");
					this.querySelector(".btn-text")?.classList.remove("hidden");
			
				});
		}
	};
}

customElements.define("quick-add-opener", QuickAddOpener);

class SliderComponent extends HTMLElement {
	constructor() {
		super();
		// Parse the JSON string from the data-slider attribute
		try {
			this.sliderData = JSON.parse(this.getAttribute("data-slider")) || {};
		} catch (error) {
			console.error("Error parsing data-slider attribute:", error);
			this.sliderData = {};
		}
	}

	connectedCallback() {
		this.sliderElement = this.querySelector(".main-carousel");

		if (!this.sliderElement) {
			return;
		}

		// Merge user-defined options with default options
		const flickityOptions = {
			cellAlign: "center",
			contain: true,
			pageDots: true,
			wrapAround: false,
			prevNextButtons: false,
			draggable: true,
			...this.sliderData.options,
		};

		const responsive = { ...this.sliderData.responsive };

		this.flickity = new Flickity(this.sliderElement, flickityOptions);

		this.thumbnailsElement = this.querySelector(".carousel-thumbnails");

		if (this.thumbnailsElement) {
			const thumbnailOptions = {
				asNavFor: ".main-carousel",
				pageDots: false,
				contain: true,
				prevNextButtons: false,
				...this.sliderData.thumbnailOptions,
			};

			this.flickity1 = new Flickity(this.thumbnailsElement, thumbnailOptions);
		}
	}

	disconnectedCallback() {
		// Clean up resources if needed
		if (this.flickity) {
			this.flickity.destroy();
		}

		if (this.flickity1) {
			this.flickity1.destroy();
		}
	}
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
	constructor() {
		super();
	}
}

customElements.define("slideshow-component", SlideshowComponent);

customElements.define(
	"en-drawer",
	class extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.addEventListener("click", () => this.handleClick);
		}

		disconnectedCallback() {
			this.removeEventListener("click", () => this.handleClick);
		}

		handleClick() {}
	}
);

customElements.define(
	"open-drawer",
	class extends HTMLElement {
		constructor() {
			super();
			this.addEventListener("click", this.openDrawer.bind(this));
		}

		openDrawer() {
			const drawerId = this.getAttribute("data-drawer");
			const drawer = document.querySelector(`en-drawer[data-id="${drawerId}"]`);
			if (drawer) {
				drawer.setAttribute("expanded", "");
				drawer.classList.add("visible");
				document.body.classList.add("overflow-hidden");
				drawer.addEventListener("click", (e) => {
					if (e.target.classList.contains("overlay-full") || e.target.classList.contains("drawer-close") || e.target.classList.contains("close-drawer")) {
						drawer.removeAttribute("expanded");
						drawer.classList.remove("visible");
						document.body.classList.remove("overflow-hidden");
					}
				});
			}
		}
	}
);

class DropdownMenu extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("mouseenter", () => {
			this.id = this.getAttribute("data-id");
			this.target = this.nextElementSibling;
			this.target.classList.remove("scale-y-0");
		});

		this.addEventListener("mouseleave", () => {
			this.id = this.getAttribute("data-id");
			this.target = this.nextElementSibling;
			this.target.classList.add("scale-y-0");
		});
	}
}

customElements.define("dropdown-menu", DropdownMenu);
function AdjustableHeight(Splide, Components, options) {
  const track = Components.Elements.track;
  const list = Components.Elements.list;

  const defaults = {
    whileSliding: true,
    speed: '0.4s',
  };

  let settings = defaults;
  const custom = options.adjustableHeight;

  if (custom) {
    settings.whileSliding = custom.whileSliding ?? defaults.whileSliding;
    settings.speed = custom.speed ?? defaults.speed;
  }

  function mount() {
    const eventType = settings.whileSliding ? 'move active resize' : 'active resized';
    Splide.on(eventType, adjustHeight);
  }

  function adjustHeight(newIndex) {
    let element = settings.whileSliding ? track : list;
    let slideHeight = Components.Slides.getAt(typeof newIndex === 'number' ? newIndex : Splide.index).slide.offsetHeight;

    let trackStyle = window.getComputedStyle(track);
    let trackPadding = parseInt(trackStyle.paddingTop) + parseInt(trackStyle.paddingBottom);
    let totalHeight = settings.whileSliding ? slideHeight + trackPadding : slideHeight;

    list.style.alignItems = 'flex-start';
    element.style.transition = 'height ' + settings.speed;
    element.style.height = totalHeight + 'px';
  }

  return {
    mount,
  };
}
class SplideComponent extends HTMLElement {
    constructor() {
        super();
        try {
            this.splideData = JSON.parse(this.getAttribute("data-splide")) || {};
        } catch (error) {
            console.error("Error parsing data-splide attribute:", error);
            this.splideData = {};
        }
    }
    
    connectedCallback() {
        this.splideElement = this.querySelector(".splide");
        if (!this.splideElement) {
            console.error("Splide element not found. Make sure you have an element with class 'splide'");
            return;
        }
        
        const splideOptions = {
            type: "slide",
            rewind: false,
            ...this.splideData,
        };
        
        this.main = new Splide(this.splideElement, splideOptions);
        this.thumbnailsElement = this.querySelector(".splide-thumbnails");
        
        if (this.thumbnailsElement) {
            try {
                this.thumbnailsData = JSON.parse(this.getAttribute("data-thumbnails")) || {};
            } catch (error) {
                console.error("Error parsing data-thumbnails attribute:", error);
                this.thumbnailsData = {};
            }
            
            const thumbnailOptions = {
                isNavigation: true,
                ...this.thumbnailsData,
            };
            
            this.thumbnails = new Splide(this.thumbnailsElement, thumbnailOptions);
            this.main.sync(this.thumbnails);
            this.main.mount();
            this.thumbnails.mount();
        } else {
            if (this.splideData.adjustableHeight) {
                this.main.mount({ AdjustableHeight });
            } else {
                this.main.mount();
            }
        }
        
        // Add event listener to the next button
        const nextButtons = document.querySelectorAll("[data-step-next]");
        if (nextButtons.length > 0) {
            nextButtons.forEach((nextButton) => {
                nextButton.addEventListener("click", () => {
                    const nextStep = nextButton.getAttribute("data-step-next");
                    // No scrolling for click events
                    this.gotoSlide(nextStep, false);
                });
            });
        }
        
        // Listen for hash changes
        window.addEventListener("hashchange", () => {
            const hash = window.location.hash.substring(1);
            // Enable scrolling for URL navigation
            this.gotoSlide(hash, true);
        });
        
        // Navigate to the slide based on initial hash
        const initialHash = window.location.hash.substring(1);
        if (initialHash) {
            // Enable scrolling for initial URL navigation
            this.gotoSlide(initialHash, true);
        }
    }
    
    disconnectedCallback() {
        if (this.main) {
            this.main.destroy();
            if (this.thumbnails) {
                this.thumbnails.destroy();
            }
        }
    }
    
    // Updated function with shouldScroll parameter
    gotoSlide(step, shouldScroll = false) {
        if (!step) return false;
        
        // Get the original slides (not the clones)
        const slides = Array.from(this.querySelectorAll(".splide__slide:not(.splide__slide--clone)"));
        let foundSlide = false;
        
        // Find the actual slide with the matching data-step
        for (let i = 0; i < slides.length; i++) {
            if (slides[i].dataset.step === step) {
                // Use Splide's built-in go method with the correct index
                this.main.go(i);
                foundSlide = true;
                
                // Add scrolling behavior only if shouldScroll is true
                if (shouldScroll) {
                    setTimeout(() => {
                        // Get the current position of the element
                        const elementPosition = this.getBoundingClientRect().top;
                        // Calculate position with 100px offset
                        const offsetPosition = elementPosition + window.pageYOffset - 300;
                        
                        // Scroll to the element with offset
                        window.scrollTo({
                            top: offsetPosition,
                            behavior: 'smooth'
                        });
                    }, 100);
                }
                
                break;
            }
        }
        
        return foundSlide;
    }
}

customElements.define("splide-component", SplideComponent);

class ProductModel extends HTMLElement {
	constructor() {
		super();
		this.openModelModal();
		this.addEventListener("click", this.loadContent);
	}

	loadContent() {
		Shopify.loadFeatures([
			{
				name: "model-viewer-ui",
				version: "1.0",
				onLoad: this.setupModelViewerUI.bind(this),
			},
		]);
	}

	setupModelViewerUI(errors) {
		if (errors) return;
		this.modelViewerUI = new Shopify.ModelViewerUI(document.querySelector("model-viewer"));
	}

	getMediaID() {
		const id = this.getAttribute("data-media-id");
		return id;
	}

	getModal() {
		const modal = document.getElementById("productModelModal");
		return modal;
	}

	openModelModal() {
		const mediaID = this.getMediaID();
		const modal = this.getModal();

		if (!mediaID) return;

		const openModalButton = this.querySelector(`button[id="productModelOpenButton_${mediaID}"]`);

		openModalButton.addEventListener("click", function (e) {
			modal.querySelector("#body").innerHTML = "";

			const template = document.querySelector(`product-model[data-media-id="${mediaID}"] > template`);
			const clone = template.content.cloneNode(true);
			modal.querySelector("#body").appendChild(clone);
			modal.querySelector("#body > model-viewer").setAttribute("reveal", "auto");
		});
	}
}

const productModel = customElements.define("product-model", ProductModel);

const inputs = document.querySelectorAll(".form-control input");
const labels = document.querySelectorAll(".form-control label");

labels.forEach((label) => {
	label.innerHTML = label.innerText
		.split("")
		.map((letter, idx) => `<span>${letter}</span>`)
		.join("");
});

window.addEventListener("beforeunload", function () {
	document.body.classList.add("animate-out");
});

document.addEventListener("DOMContentLoaded", function () {
	document.body.classList.remove("animate-out");
});
window.addEventListener("pageshow", function (event) {
	document.body.classList.remove("animate-out");
});

document.addEventListener("DOMContentLoaded", function () {
	if (!document.getElementById("header-light-mode")) {
		document.querySelector("header").classList.add("header-alt");

		var navigation = document.querySelector("header .navMenu");
		navigation.classList.toggle("text-tertiary");
		navigation.classList.toggle("text-primary");
	}
});


document.addEventListener("DOMContentLoaded", () => {
	// Attach the event listener to a parent element
	document.addEventListener("change", (event) => {
		const target = event.target;
		// Check if the changed element is a radio input inside a .variant-select
		if (target.matches('.variant-select input[type="radio"]')) {
			const lineItem = target.closest(".line-item");
			const oldVariantId = lineItem.dataset.itemId;
			const newVariantId = target.value;
			let qty = +lineItem.querySelector(".item-quantity").getAttribute("value");
			
			// Collect all the properties from the original item
			const properties = {};
			lineItem.querySelectorAll('[data-ajax-cart-property-input]').forEach(input => {
				const propertyName = input.name.match(/properties\[(.*?)\]/)[1];
				properties[propertyName] = input.value;
			});
			
			target
				.closest("[data-ajax-cart-section]")
				.querySelectorAll('[data-ajax-cart-section] [data-item-id="' + newVariantId + '"]')
				.forEach(function (item) {
					qty += +item.querySelector(".item-quantity").getAttribute("value");
				});
				
			// Prepare the updates object
			const updates = {
				[oldVariantId]: 0,
				[newVariantId]: qty,
			};
			
			// Use the cart.add method first to add with properties, then update
			if (Object.keys(properties).length > 0) {
              
					liquidAjaxCart.update({ updates: { [oldVariantId]: 0 } });
              setTimeout(() => {
              lineItem.style.display = 'none';
			}, 1000);
				liquidAjaxCart.add({
					id: newVariantId,
					quantity: qty,
					properties: properties
				});
			} else {
				// If no properties, use the original update method
				liquidAjaxCart.update({ updates });
			}
		}
	});
});

document.addEventListener("DOMContentLoaded", () => {
	document.addEventListener("click", (event) => {
		const target = event.target;
		if (target.matches(".product-card .remove-cart-item")) {
			const productCard = target.closest(".product-card");
			const variantId = productCard.dataset.added;

			const updates = {
				[variantId]: 0,
			};

			liquidAjaxCart.update({ updates });
			setTimeout(() => {
				productCard.removeAttribute("data-added");
			}, 1000);
		}
	});
});

document.addEventListener("DOMContentLoaded", () => {
    document.addEventListener("click", function (event) {
        const clickedButton = event.target;
        if (clickedButton.tagName === "BUTTON" && clickedButton.type === "submit" && clickedButton.name === "add") {
            handleClick(event);
        }
    });
    function handleClick(event) {
        const clickedButton = event.target;
        document.addEventListener("liquid-ajax-cart:request-end", handleCartRequest);
        function handleCartRequest(event) {
            const { requestState } = event.detail;
            if (requestState.requestType === "add" && requestState.responseData?.ok) {
                if (!clickedButton.hasAttribute("no-cart-drawer")) {
                    document.querySelector('open-drawer[data-drawer="cart-drawer"]').click();
                    // Popup settings
                } else if (clickedButton.hasAttribute("data-plan-name")) {
                    const varid = clickedButton.closest("form").querySelector('input[name="id"]').value;
                    const card = document.querySelector('.product-card[modal-open="' + clickedButton.getAttribute("product-id") + '"]');
                    if (card) {
                        card.setAttribute("data-added", varid);
                        card.querySelector(".remove-cart-item > span").textContent = clickedButton.querySelector("span").getAttribute("remove-text");
                    }
                } else {
                    const card = clickedButton.closest(".product-card");
                    if (card) {
                        const productId = card.querySelector('input[name="id"]').value;
                        card.setAttribute("data-added", productId);
                    }
                }
                // Close popup for all successful cart additions
                const quickAddContainer = clickedButton.closest('[quickadd-id^="QuickAdd-"]');
                if (quickAddContainer) {
                    const closeButton = quickAddContainer.querySelector(".close-modal");
                    if (closeButton) closeButton.click();
                }
            }
            document.removeEventListener("liquid-ajax-cart:request-end", handleCartRequest);
        }
    }
});
function convertButtonVSAnchor(element) {
	if (element.tagName.toLowerCase() === "button") {
		var newelement = document.createElement("a");
	} else if (element.tagName.toLowerCase() === "a") {
		var newelement = document.createElement("button");
	}
	Array.from(element.attributes).forEach(function (attr) {
		newelement.setAttribute(attr.name, attr.value);
	});

	while (element.firstChild) {
		newelement.appendChild(element.firstChild);
	}

	element.parentNode.replaceChild(newelement, element);
}

function UpdateTitles(element) {
	if (element.hasAttribute("data-page-title")) {
		var pageTitle = element.getAttribute("data-page-title");
		document.getElementById("pageTitle").innerText = pageTitle;
	}
	if (element.hasAttribute("data-page-subtitle")) {
		var pageSubtitle = element.getAttribute("data-page-subtitle");
		document.getElementById("pageSubtitle").innerText = pageSubtitle;
	}
}

if (typeof window.Shopify == "undefined") {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent("on" + eventName, callback);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

	Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute("data-default");
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute("data-provinces");
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.parentElement.style.display = "none";
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement("option");
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.parentElement.style.display = "";
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement("option");
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},
};

function autoFreeGift() {
  const autoaddedProp = "_autoadded";
  const thresholdProp = "_threshold";
  const cart = window.liquidAjaxCart.cart;
  const config = window.gwpConfig || { blocks: [], progressMax: 100 };

  const total = cart.items_subtotal_price / 100;
  const requests = [];

  if (total === 0) {
    if (cart.items && cart.items.length > 0) {
      cart.items.forEach(item => {
        if (item && item.variant_id) {
          requests.push({
            type: "update",
            body: { updates: { [item.variant_id]: 0 } }
          });
        }
      });
    }
    return { requests };
  }

  const allGiftBlocks = config.blocks.filter(
    b => !b.freeShipping && Array.isArray(b.productVariants) && b.productVariants.length > 0
  );

  const allGiftVariants = allGiftBlocks.flatMap(b => b.productVariants.map(Number));

  const purchasableItems = cart.items.filter(i =>
    i &&
    !allGiftVariants.includes(i.variant_id) &&
    (!i.properties || i.properties[autoaddedProp] !== "Yes") &&
    i.product_type !== "Gift Card"
  );

  const purchasableTotal = purchasableItems.reduce((sum, item) => {
    const linePrice = item.final_line_price || item.line_price || 0;
    return sum + (linePrice / 100);
  }, 0);

  const staleAutoItems = cart.items.filter(i =>
    i && i.properties && i.properties[autoaddedProp] === "Yes" &&
    !allGiftVariants.includes(i.variant_id)
  );

  if (staleAutoItems.length > 0) {
    staleAutoItems.forEach(item => {
      requests.push({
        type: "update",
        body: { updates: { [item.variant_id]: 0 } }
      });
    });
  }

  const eligibleBlocks = allGiftBlocks.filter(block =>
    block && block.threshold && purchasableTotal >= block.threshold
  );

  const ineligibleBlocks = allGiftBlocks.filter(block =>
    !block || !block.threshold || purchasableTotal < block.threshold
  );

  if (ineligibleBlocks.length > 0) {
    const ineligibleVariants = ineligibleBlocks.flatMap(b => b.productVariants.map(Number));
    const eligibleVariants = eligibleBlocks.flatMap(b => b.productVariants.map(Number));
    const trulyIneligibleVariants = ineligibleVariants.filter(id => !eligibleVariants.includes(id));
    const itemsToRemove = cart.items.filter(i => trulyIneligibleVariants.includes(i.variant_id));

    itemsToRemove.forEach(item => {
      requests.push({
        type: "update",
        body: { updates: { [item.variant_id]: 0 } }
      });
    });
  }

  if (eligibleBlocks.length > 0) {
    eligibleBlocks.forEach(block => {
      const blockVariants = block.productVariants.map(Number);
      const existingBlockItems = cart.items.filter(i => blockVariants.includes(i.variant_id));

      let targetVariantId = null;

      if (existingBlockItems.length > 0) {
        const manualItem = existingBlockItems.find(i => !i.properties || i.properties[autoaddedProp] !== "Yes");
        targetVariantId = manualItem ? manualItem.variant_id : existingBlockItems[0].variant_id;
      } else {
        targetVariantId = blockVariants[0];
      }

      const targetItem = cart.items.find(i => i.variant_id === targetVariantId);

      if (!targetItem) {
        // Not in cart: add with threshold property
        requests.push({
          type: "add",
          body: {
            items: [{
              id: targetVariantId,
              quantity: 1,
              properties: {
                [autoaddedProp]: "Yes",
                [thresholdProp]: block.threshold  // e.g. 50 (euros)
              }
            }]
          }
        });
      } else if (targetItem.quantity !== 1) {
        // Wrong qty: remove then re-add to preserve/refresh properties
        requests.push({
          type: "update",
          body: { updates: { [targetVariantId]: 0 } }
        });
        requests.push({
          type: "add",
          body: {
            items: [{
              id: targetVariantId,
              quantity: 1,
              properties: {
                [autoaddedProp]: "Yes",
                [thresholdProp]: block.threshold
              }
            }]
          }
        });
      }
      // If qty is already 1 but _threshold is missing or stale, refresh it
      else if (
        targetItem.properties &&
        targetItem.properties[autoaddedProp] === "Yes" &&
        String(targetItem.properties[thresholdProp]) !== String(block.threshold)
      ) {
        requests.push({
          type: "update",
          body: { updates: { [targetVariantId]: 0 } }
        });
        requests.push({
          type: "add",
          body: {
            items: [{
              id: targetVariantId,
              quantity: 1,
              properties: {
                [autoaddedProp]: "Yes",
                [thresholdProp]: block.threshold
              }
            }]
          }
        });
      }

      // Remove other variants from this block
      const otherItemsInBlock = existingBlockItems.filter(i => i.variant_id !== targetVariantId);
      otherItemsInBlock.forEach(item => {
        requests.push({
          type: "update",
          body: { updates: { [item.variant_id]: 0 } }
        });
      });
    });
  }

  return { requests };
}

if (window.liquidAjaxCart && window.liquidAjaxCart.conf) {
  window.liquidAjaxCart.conf("mutations", [autoFreeGift]);
}

// Function to get visitor's country handle
async function getVisitorCountry() {
  try {
    const response = await fetch('/browsing_context_suggestions.json');
    const data = await response.json();
    return data.detected_values.country.handle.toUpperCase(); // Returns 'IN', 'US', etc.
  } catch (error) {
    console.error('Error fetching country:', error);
    return null;
  }
}

class StoreSwitcher extends HTMLElement {
  constructor() {
    super();
    this.switcher = this.querySelector('#store-switcher');
    this.backdrop = this.querySelector('#store-switcher-backdrop');
    this.closeBtn = this.querySelector('button[aria-label="Close"]');
  }

  connectedCallback() {
    if (!this.switcher) return;

    // Check if dismissed in current session
    const isClosed = sessionStorage.getItem('fler_store_switcher_closed');
    if (isClosed) return;

    this.init();

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.close.bind(this));
    }
    const stayBtn = this.querySelector('#store-switcher-stay');
    if (stayBtn) {
      stayBtn.addEventListener('click', this.close.bind(this));
    }
    if (this.backdrop) {
      this.backdrop.addEventListener('click', this.close.bind(this));
    }
  }

  async init() {
    const country = await getVisitorCountry();
    if (country && country == 'US') {
      this.switcher.classList.remove('hidden');
      if (this.backdrop) this.backdrop.classList.remove('hidden');
    }
  }

  close() {
    this.switcher.classList.add('hidden');
    if (this.backdrop) this.backdrop.classList.add('hidden');
    sessionStorage.setItem('fler_store_switcher_closed', 'true');
  }
}

customElements.define('store-switcher', StoreSwitcher);
